import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

// Importing altcha package will introduce a new element <altcha-widget>
import 'altcha'
// import {AltchaWidget, AltchaWidgetMethods} from 'altcha'

/**
 * ExampleComponent is an example component.
 * It takes a property, `label`, and
 * displays it.
 * It renders an input with the property `value`
 * which is editable by the user.
 */
const DashAltchaComponent = (props) => {
    const {id, label, challengeUrl, setProps, value} = props;

    const widgetRef = useRef(null)
        
    const handleAltchaChange = (e) => {
        /*
        * Send the new value to the parent component.
        * setProps is a prop that is automatically supplied
        * by dash's front-end ("dash-renderer").
        * In a Dash app, this will update the component's
        * props and send the data back to the Python Dash
        * app server if a callback uses the modified prop as
        * Input or State.
        */
        if ('detail' in e) {
            setProps({ value: e.detail.payload });
        }
    };
    
    useEffect(() => {
        // Wait for the widget to be fully initialized
        if (widgetRef.current) {
            // Add event listener for state changes
            widgetRef.current.addEventListener('statechange', handleAltchaChange);
            
            // Clean up the event listener when component unmounts
            return () => {
                if (widgetRef.current) {
                    widgetRef.current.removeEventListener('statechange', handleAltchaChange);
                }
            };
        }
    }, [widgetRef.current]); // Re-run effect if widgetRef.current changes    

    return (
            <altcha-widget
                ref={widgetRef}
                id={id}
                style={{
                    '--altcha-max-width': '100%',
                }}
                debug
                challengeurl={challengeUrl}
                >
            </altcha-widget>
    );
}

DashAltchaComponent.defaultProps = {};

DashAltchaComponent.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks.
     */
    id: PropTypes.string,

    /**
     * A label that will be printed when this component is rendered.
     */
    challengeUrl: PropTypes.string.isRequired,

    /**
     * A label that will be printed when this component is rendered.
     */
    label: PropTypes.string.isRequired,

    /**
     * The value displayed in the input.
     */
    value: PropTypes.string,

    /**
     * Dash-assigned callback that should be called to report property changes
     * to Dash, to make them available for callbacks.
     */
    setProps: PropTypes.func
};

export default DashAltchaComponent;
